export default __webpack_public_path__ + "static/media/expYellow.22be417c.svg";